/**
 * Unified Tracking - Meta Pixel + TikTok Pixel
 * Meta Pixel ID: 1195019342732925
 * TikTok Pixel ID: D4NGNJRC77UA1JCQ4G1G
 * 
 * Centralizes all tracking events to fire on BOTH platforms simultaneously
 * Both platforms now use dual tracking: client-side + server-side (Conversions API)
 */

import { trackFacebookLead, trackFacebookInitiateCheckout, trackFacebookPurchase } from './facebook-tracking';
import { trackTikTokLead, trackTikTokInitiateCheckout, trackTikTokPurchase } from './tiktok-tracking';

// Product constants
const PRODUCT = {
  id: 'kit-marca-completo',
  name: 'Kit Marca Completo',
  value: 89.90,
  currency: 'BRL',
};

/**
 * Lead - When user clicks "Criar Minha Marca" or generates something
 */
export function trackLead(contentName?: string, userEmail?: string, userId?: string) {
  const name = contentName || 'Logo/Brand Generation';
  
  // Meta Pixel + Conversions API
  trackFacebookLead(name, userEmail, userId);
  
  // TikTok Pixel + Events API
  trackTikTokLead(name, userEmail, userId);
  
  console.log('📊 Unified Lead tracked:', name);
}

/**
 * InitiateCheckout - When paywall modal opens
 */
export function trackInitiateCheckout(params?: {
  value?: number;
  productName?: string;
  userEmail?: string;
  userId?: string;
}) {
  const value = params?.value || PRODUCT.value;
  const name = params?.productName || PRODUCT.name;
  
  // Meta Pixel + Conversions API
  trackFacebookInitiateCheckout({
    value,
    currency: PRODUCT.currency,
    content_name: name,
    content_ids: [PRODUCT.id],
    userEmail: params?.userEmail,
    userId: params?.userId,
  });
  
  // TikTok Pixel + Events API
  trackTikTokInitiateCheckout(
    PRODUCT.id,
    value,
    params?.userEmail,
    params?.userId
  );
  
  console.log('📊 Unified InitiateCheckout tracked:', value);
}

/**
 * Purchase - After payment confirmed
 */
export function trackPurchase(params?: {
  orderId?: string;
  value?: number;
  productName?: string;
  userEmail?: string;
  userId?: string;
}) {
  const value = params?.value || PRODUCT.value;
  const name = params?.productName || PRODUCT.name;
  
  // Meta Pixel + Conversions API
  trackFacebookPurchase({
    value,
    currency: PRODUCT.currency,
    content_name: name,
    content_ids: [PRODUCT.id],
    userEmail: params?.userEmail,
    userId: params?.userId,
    orderId: params?.orderId,
  });
  
  // TikTok Pixel + Events API
  trackTikTokPurchase(
    params?.orderId || 'unknown',
    value,
    PRODUCT.id,
    params?.userEmail,
    params?.userId
  );
  
  console.log('📊 Unified Purchase tracked:', value);
}
